import { render, staticRenderFns } from "./MessageLogs.vue?vue&type=template&id=44da80fa&scoped=true&"
import script from "./MessageLogs.vue?vue&type=script&lang=js&"
export * from "./MessageLogs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44da80fa",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/sivaram/work/carthike/whatsapp-crm-client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('44da80fa')) {
      api.createRecord('44da80fa', component.options)
    } else {
      api.reload('44da80fa', component.options)
    }
    module.hot.accept("./MessageLogs.vue?vue&type=template&id=44da80fa&scoped=true&", function () {
      api.rerender('44da80fa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Marketing/MessageLogs.vue"
export default component.exports